import * as yup from "yup";

export const WireTransferSetupValidationSchema = yup.object().shape({
	date: yup.string().required("Date is required"),
	wireAmount: yup.string().required("Wire Amount is required"),
	wireMethod: yup.string().required("Wire Method is required"),
	confirmationNo: yup.string().required("Confirmaton No is required"),
});
